import { Button } from '@/src/components/Commons/Button';
import LoaderButton from '@/src/components/Commons/LoaderButton/LoaderButton';
import { useAppStore } from '@/src/store/global';
import React, { Dispatch, Fragment, SetStateAction } from 'react';
import FailedIcon from '../../Commons/FailedIcon/FailedIcon';
import SuccessIcon from '../../Commons/SuccessIcon/SuccessIcon';
import styles from './TaskProcessing.module.scss';

interface ITaskProcessingProps {
    isProcessingTask: boolean;
    processingTaskMessage: string;
    isFaildedTask: boolean;
    setIsFaildedTask: Dispatch<SetStateAction<boolean>>;
    isConfirmedTask: boolean;
    setIsConfirmedTask: Dispatch<SetStateAction<boolean>>;
    onRetryTask?: () => Promise<void>;
    onFinishTask?: (swBackToDashboard?: boolean | undefined) => Promise<void>;
    showNewTaskButton?: boolean;
    nameForNewTaskButton?: string;
    nameForCloseButton?: string;
    othersButtonsWhenConfirmed?: React.ReactNode;
    othersButtonsWhenFailed?: React.ReactNode;
    othersButtonsWhenProcessing?: React.ReactNode;
}

const TaskProcessing: React.FC<ITaskProcessingProps> = (props) => {
    const {
        isProcessingTask,
        isFaildedTask,
        setIsFaildedTask,
        isConfirmedTask,
        setIsConfirmedTask,
        processingTaskMessage,
        onRetryTask,
        onFinishTask,
        showNewTaskButton: showNewTaskButton_,
        othersButtonsWhenConfirmed,
        othersButtonsWhenFailed,
        othersButtonsWhenProcessing,
    } = props;
    //--------------------------------------
    const nameForNewTaskButton = props.nameForNewTaskButton !== undefined ? props.nameForNewTaskButton : 'New Task';
    const showNewTaskButton = showNewTaskButton_ !== undefined ? showNewTaskButton_ : true;
    const nameForCloseButton = props.nameForCloseButton !== undefined ? props.nameForCloseButton : 'Close';
    //--------------------------------------
    const appStore = useAppStore();
    //--------------------------------------
    return (
        <Fragment>
            <table className={styles.tableForm}>
                <tbody>
                    <tr>
                        <td>
                            <div className={styles.taskProcessing}>
                                <h2 className={styles.title}>TASK MODULE</h2>
                                {isProcessingTask ? (
                                    <>
                                        <div className={styles.textPart}>
                                            <LoaderButton />
                                            <h2 className={styles.title}>PROCESSING YOUR TASK</h2>
                                            <p className={styles.text}>{processingTaskMessage}</p>
                                        </div>
                                        {othersButtonsWhenProcessing !== undefined ? (
                                            <div className={styles.buttonPart}>
                                                <div className={styles.buttonsBelowForm}>{othersButtonsWhenProcessing}</div>
                                            </div>
                                        ) : null}
                                    </>
                                ) : isConfirmedTask ? (
                                    <>
                                        <div className={styles.textPart}>
                                            <SuccessIcon />
                                            <h2 className={styles.title}>CONGRATULATIONS</h2>
                                            <p className={styles.text}>We are thrilled to inform you that your recent task has been completed successfully!</p>
                                            {showNewTaskButton === true || othersButtonsWhenConfirmed !== undefined ? (
                                                <p className={styles.text}>What do you want to do next?</p>
                                            ) : null}
                                        </div>
                                        <div className={styles.buttonPart}>
                                            <div className={styles.buttonsBelowForm}>
                                                {showNewTaskButton ? (
                                                    <Button mode="action" size="large" width={200} onClick={() => setIsConfirmedTask(false)}>
                                                        {nameForNewTaskButton}
                                                    </Button>
                                                ) : null}
                                                {othersButtonsWhenConfirmed}
                                                <Button mode="action" size="large" onClick={() => onFinishTask?.(true)}>
                                                    {nameForCloseButton}
                                                </Button>
                                            </div>
                                        </div>
                                    </>
                                ) : isFaildedTask ? (
                                    <>
                                        <div className={styles.textPart}>
                                            <FailedIcon />
                                            <h2 className={styles.title}>SOMETHING WENT WRONG</h2>
                                            <p className={styles.text}>We are very sorry to inform you that your recent task has failed! You can try again!</p>
                                            <p className={styles.text}>{processingTaskMessage}</p>
                                        </div>
                                        <div className={styles.buttonPart}>
                                            <div className={styles.buttonsBelowForm}>
                                                <Button
                                                    mode="action"
                                                    size="large"
                                                    width={200}
                                                    onClick={() => {
                                                        setIsFaildedTask(false);
                                                        onRetryTask?.();
                                                    }}
                                                >
                                                    Try Again
                                                </Button>
                                                {othersButtonsWhenFailed}
                                                <Button mode="action" size="large" onClick={() => onFinishTask?.(true)}>
                                                    {nameForCloseButton}
                                                </Button>
                                            </div>
                                        </div>
                                    </>
                                ) : null}
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </Fragment>
    );
};

export default TaskProcessing;
